import { FragmentType } from "../../__generated__/gql";
import ContentBriefForm, {
  EditArticleBriefFragment,
} from "../Articles/components/ArticleTable/EditArticleModal/ContentBriefForm";

function ArticleContentBrief({
  data,
  onChange,
  creditsRequired,
}: {
  data: FragmentType<typeof EditArticleBriefFragment>;
  onChange: (isDirty: boolean) => void;
  creditsRequired?: number;
}) {
  return (
    <ContentBriefForm
      data={data}
      onChange={onChange}
      creditsRequired={creditsRequired}
    />
  );
}

export default ArticleContentBrief;
